import { Typography } from "@codat/orchard-ui";
import React from "react";

import styles from "../CompaniesTable/CompaniesTable.module.scss";

export type LastPulledCellModel = {
  key: "lastSync";
  value: string;
};

export function LastPulledCell({ value }: Pick<LastPulledCellModel, "value">) {
  return (
    <Typography
      as="div"
      className={styles.lastPulledDate}
      data-testid="companies-table-lastpulled"
      variant="body_sm"
    >
      {value}
    </Typography>
  );
}
